// Pre-chat PHI warning modal. The user must acknowledge before the
// chat surface accepts input. Playbook reference: Section 5.15.
// Acknowledgment is per-session (React state); next page load
// re-shows the warning, by design.

import { Modal } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { useDemoMode } from '../hooks/useDemoMode';

interface Props {
  onAcknowledge: () => void;
}

export function PreChatPhiWarning({ onAcknowledge }: Props) {
  const [open, setOpen] = useState(true);
  const demoMode = useDemoMode();

  useEffect(() => {
    if (demoMode && open) {
      setOpen(false);
      onAcknowledge();
    }
  }, [demoMode, open, onAcknowledge]);

  if (demoMode) return null;

  function handleConfirm() {
    setOpen(false);
    onAcknowledge();
  }

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      title="Before you chat"
      primaryAction={{
        content: 'I understand, start chatting',
        onAction: handleConfirm,
      }}
    >
      <Modal.Section>
        <p style={{ fontSize: 'var(--font-size-base)', lineHeight: 'var(--line-height)' }}>
          Siggy can help you understand your medications and the flags raised on your list.
        </p>
        <p style={{ fontSize: 'var(--font-size-base)', lineHeight: 'var(--line-height)' }}>
          For your privacy, please do not share your full name, date of birth, social security
          number, home address, or phone number in this chat. We do not need them to help you.
        </p>
        <p style={{ fontSize: 'var(--font-size-base)', lineHeight: 'var(--line-height)' }}>
          This is educational. For decisions about your medications, talk to your doctor and
          pharmacist.
        </p>
      </Modal.Section>
    </Modal>
  );
}
